// src/blocks/icon/SVGs/arrow-short.tsx
import * as React from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var ArrowShortSVG = ({
  title = "Arrow (Short) Icon",
  desc = "Arrow (Short) Icon",
  descId,
  width = 16,
  height = 16,
  direction,
  className,
  ...props
}) => {
  const titleId = React.useId();
  const decriptionId = React.useId();
  let tilt = "rotate-0";
  switch (direction) {
    case "up":
      tilt = "rotate-270";
      break;
    case "down":
      tilt = "rotate-90";
      break;
    case "left":
      tilt = "rotate-180";
      break;
    case "right":
      tilt = "rotate-0";
      break;
    case "top-right":
      tilt = "rotate-315";
      break;
  }
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width,
      height,
      viewBox: "0 0 8 8",
      xmlns: "http://www.w3.org/2000/svg",
      className: `${tilt} ${className}`,
      fill: "none",
      "aria-labelledby": titleId,
      "aria-describedby": decriptionId,
      ...props,
      children: [
        desc ? /* @__PURE__ */ jsx("desc", { id: decriptionId, children: desc }) : null,
        /* @__PURE__ */ jsx("title", { id: titleId, children: title }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M4.08163 8L3.40816 7.32143L6.18076 4.49107H0V3.50893H6.18076L3.40816 0.6875L4.08163 0L8 4L4.08163 8Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
};
var arrow_short_default = ArrowShortSVG;

export {
  arrow_short_default
};
